const FavoriteButtonTemplate = () => `
  <i class="far fa-heart" id="likeButton" aria-hidden="true" aria-label="favorite this restaurant"></i>
`

export default FavoriteButtonTemplate
